import { path } from "d3";
import instance from "../../helpers/Axios.Config";
import fileInstance from "../../helpers/File.Axios.Config";
import paths from "../../Routes/paths";

var url = paths.materialcomunicacao;

class MaterialcomunicacaoAPI {
  static async getAsync(id) {
    try {
      var result = await instance.get(url + "/get/" + id);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getListPagedAsync(params) {
    try {
      var result = await instance.get(url + "/get-list-paged", {
        params: params,
      });

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async addAsync(material) {
    try {
      var result = await instance.post(url + "/add", material);
      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async updateAsync(material) {
    try {
      var result = await instance.post(url + "/update", material);
      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async removeAsync(id) {
    try {
      var result = await instance.post(url + `/remove/${id}`);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getSelectListAsync(mcTipoId = 0, frete = -1, producao = -1) {
    try {
      var result = await instance.get(
        url +
          "/get-select-list?mcTipoId=" +
          mcTipoId +
          "&frete=" +
          frete +
          "&producao=" +
          producao,
      );

      return result.data.value || [];
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getList() {
    try {
      var result = await instance.get(url + "/get-list");

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getMaterialList() {
    try {
      var result = await instance.get(url + "/get-material-list");

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getSelectListFreteAsync() {
    return this.getSelectListAsync(0, 1, -1);
  }

  static async getSelectListProducaoAsync() {
    return this.getSelectListAsync(0, -1, 1);
  }

  static async uploadImageAsync(materialComunicacaoId, fileImagem) {
    const formData = new FormData();
    if (fileImagem) {
      formData.append("materialComunicacaoId", materialComunicacaoId);
      formData.append("file", fileImagem);
    }
    var result = await fileInstance.post(
      url + "/upload-arte-material-comunicacao",
      formData,
    );
    return result;
  }

  static async updateOrder(materiais) {
    try {
      var result = await instance.post(`${url}/update-ordem`, materiais);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getListByCanal(canalId) {
    try {
      var result = await instance.get(
        `${url}/get-list-by-canal?canalId=${canalId}`,
      );
      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async updateOrderCanal(payload) {
    try {
      var result = await instance.post(`${url}/update-ordem-canal`, payload);
      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }
}

export default MaterialcomunicacaoAPI;
